module.exports = __webpack_public_path__ + "media/images/app/visitors/how-it-works/hero_mobile-5aabdbb5194e2675e7c13d53a72f17cf.webp";